import React, { useState, useEffect } from "react";
import { Button,
  Table
 } from "react-bootstrap";
import { colors, initialShift } from "../configs";
import { useSelector, useDispatch } from "react-redux";
import { formatCurrency, summary } from "../Utility/function";
import { stringYMDHMS3, stringDateTimeReceipt } from "../Utility/dateTime";
import Modal_Loading from "../modal/Modal_Loading";
import '../styles/CartScreen.css'
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from 'react-i18next';
import { Modal_Shift } from "../modal";
import * as XLSX from 'xlsx';
import { TimeControlShift } from "../components";
// import Download from "./Download";

const { darkGray, white } = colors;

function ReportShiftScreen() {
  const { t } = useTranslation();
  const { shop } = useSelector((state)=> state.shop);
  const { name:shopName, POSs  } = shop;
  const { modal_Shift, displayShifts, startDate, endDate } = useSelector(state=>state.shift)
  const [shift_Modal, setShift_Modal] = useState(false);
  const [current, setCurrent] = useState(initialShift)

  const [display, setDisplay] = useState([]);

  useEffect(()=>{
    const cashiers = new Map(POSs.map(a=>[a.shiftId,a.name]))
    let newShift = displayShifts.map(a=>{
      const { openCash, thisTotalCash, duringShift, closeCash, closeWithDraw, id } = a;
      let newDuringShift = duringShift.map(a=>({...a,amount:Number(a.amount)}))
      let increaseDuring = summary(newDuringShift.filter(a=>a.type===1),'amount')
      let decreaseDuring = summary(newDuringShift.filter(a=>a.type===2),'amount')
      let currentCash = thisTotalCash + Number(openCash) + increaseDuring - decreaseDuring
      let cashRemain = closeCash - closeWithDraw
      return {
        ...a,
        increaseDuring,
        decreaseDuring,
        currentCash,
        cashRemain,
        counterName:cashiers.get(id)||'ไม่พบ'
      }
    })
    setDisplay(newShift)

  },[displayShifts])



    const exportToXlsx = () => {
      const data = display.map((item) => {
        const { shiftCount, closeTime, openCash, thisTotalCash, closeCash, closeWithDraw, closeDiff, increaseDuring, decreaseDuring, currentCash, cashRemain } = item;
        return {
          [t('shift.no')]: shiftCount,
          [t('shift.closeTime')]: stringDateTimeReceipt(closeTime),
          [t('shift.openCash')]: openCash,
          [t('shift.betweenCash')]: thisTotalCash,
          [t('shift.inbound')]: increaseDuring,
          [t('shift.outbound')]: decreaseDuring,
          [t('shift.cashExpect')]: currentCash,
          [t('shift.countCash')]: closeCash,
          [t('shift.diff')]: closeDiff,
          [t('shift.withdraw')]: closeWithDraw,
          [t('shift.remain')]: cashRemain,
        };
      });
    
      const worksheet = XLSX.utils.json_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Shift Report');
    
      const fileName = `${t('shift.ReportShiftScreen')} [${shopName}]${stringYMDHMS3(startDate)}-${stringYMDHMS3(endDate)}.xlsx`;
      XLSX.writeFile(workbook, fileName);
    };

  return (
    <div  >
      <Modal_Loading show={modal_Shift} />
      <Modal_Shift
        show={shift_Modal}
        onHide={()=>{setShift_Modal(false)}}
        current={current}
      />
      <h1>รายงานกะ</h1>
      <TimeControlShift/>
      <div style={styles.container2} >
        <h4>&emsp;{t('shift.result',{ length:display.length })}</h4> 
        {/* <Download exportToXlsx={exportToXlsx} /> */}
        
      </div>
      <br/>
      <Table striped bordered hover responsive  variant="light" style={styles.container3}  >
                  
        <thead  >
          <tr>
            <th style={styles.text} >No.</th>
            <th style={styles.text2} >{t('shift.no')}</th>
            <th style={styles.text2} >เวลาเปิดกะ</th>
            <th style={styles.text2} >{t('shift.closeTime')}</th>
            <th style={styles.text2} >{t('shift.openCash')}</th>
            <th style={styles.text2} >{t('shift.betweenCash')}</th>
            <th style={styles.text2} >{t('shift.inbound')}</th>
            <th style={styles.text2} >{t('shift.outbound')}</th>
            <th style={styles.text2} >{t('shift.cashExpect')}</th>
            <th style={styles.text2} >{t('shift.countCash')}</th>
            <th style={styles.text2} >{t('shift.diff')}</th>
            <th style={styles.text2} >{t('shift.withdraw')}</th>
            <th style={styles.text2} >{t('shift.remain')}</th>
            <th style={styles.text2}>{t('shift.detail')}</th>
          </tr>
        </thead>
        <tbody  >
          {display.map((item, index) => {
            const { shiftCount, openTime, closeTime, openCash, thisTotalCash, closeCash, closeWithDraw, closeDiff, increaseDuring, decreaseDuring, currentCash, cashRemain } = item;
            return <tr  key={index} >
                      <td style={styles.text2}>{index+1}.</td>
                      <td style={styles.text2}>{shiftCount}</td>
                      <td style={styles.text2}>{stringDateTimeReceipt(openTime)}</td>
                      <td style={styles.text2}>{stringDateTimeReceipt(closeTime)}</td>
                      <td style={styles.text2}>{formatCurrency(Number(openCash))}</td>
                      <td style={styles.text2}>{formatCurrency(thisTotalCash)}</td>
                      <td style={styles.text2}>{formatCurrency(increaseDuring)}</td>
                      <td style={styles.text2}>{formatCurrency(decreaseDuring)}</td>
                      <td style={styles.text2}>{formatCurrency(currentCash)}</td>
                      <td style={styles.text2}>{formatCurrency(Number(closeCash))}</td>
                      <td style={styles.text2}>{formatCurrency(closeDiff)}</td>
                      <td style={styles.text2}>{formatCurrency(closeWithDraw)}</td>
                      <td style={styles.text2}>{formatCurrency(cashRemain)}</td>
                      <td style={styles.text2}>
                        <Button onClick={()=>{setCurrent(item);setShift_Modal(true)}} style={{minWidth:'100px'}} variant="warning" >{t('shift.watch')}</Button>
                      </td>
                    </tr>
          })}
        </tbody>
      </Table>


  
    </div>
  );
};

const styles = {
  text : {
    width:'5%',
    textAlign:'center',
    minWidth:'100px'
  },
  text2 : {
    width:'8%',
    textAlign:'center',
    minWidth:'180px'
  },
  container : {
    backgroundColor:darkGray,textDecoration:'none',color:white,padding:10,borderRadius:20,paddingLeft:30,paddingRight:30
  },
  container2 : {
    display:'flex',justifyContent:'space-between',marginRight:'1rem'
  },
  container3 : {
    marginLeft:'1rem'
  }
}

export default ReportShiftScreen;
